const state = {

    errors: []

}

const getters = {


    /**
     * Return errors filters by id
     * @param id Integer
     * 
     */

    getErrorsById: (state) => (id) => {

        return state.errors.filter(function(error){
            return error.componentId == id
        })

    },

}

const actions = {

    /**
     * Set error up
     * @param error Object
     * 
     */

    setError({ commit }, {error, componentId}) {

        let errorData =  {
            id: new Date().getTime(),
            componentId: componentId,
            message: error,
        }

        commit('SET_ERROR', errorData)
        
    }

}

const mutations = {

    /**
     * Commit error to the stage
     * @param error Boolean
     * 
     */
    
    SET_ERROR( state, error ) {

        state.errors.push(error)

    },

    /**
     * Remove error from stater
     * @param id Integer
     * 
     */

    REMOVE_ERROR( state, id ) {

        let error_object = state.errors.find(error => error.id === id)
        let error_index = state.errors.indexOf(error_object)

        state.errors.splice(error_index, 1)

    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}